import * as EXIF from 'exif-js';
import { Directive, ElementRef, Renderer2 } from '@angular/core';

const MEDIA_FILE = /https?:\/\/file.*\.(boldchat|bold360)\.(io|com)(:[0-9]+)?\/aid\/[0-9]+\/bc.m.media\/*/i;

@Directive({
  selector: '[appImageOrientation]'
})
export class ImageOrientationDirective {
  constructor(private _element: ElementRef, private _renderer: Renderer2) {
    const el = this._element.nativeElement;
    const setTransform = (transform) => {
      this._renderer.setStyle(el, '-ms-transform', transform);
      this._renderer.setStyle(el, '-webkit-transform', transform);
      this._renderer.setStyle(el, '-moz-transform', transform);
      this._renderer.setStyle(el, 'transform', transform);
    };
    this._renderer.setStyle(el, 'visibility', 'hidden');
    el.addEventListener('load', () => {
      const src = el.src;
      if (MEDIA_FILE.test(src)) {
        EXIF.getData(el, () => {
          const orientation = EXIF.getTag(el, 'Orientation');
          if (orientation && orientation !== 1) {
            switch (orientation) {
              case 2:
                setTransform('rotateY(180deg)');
                break;
              case 3:
                setTransform('rotate(180deg)');
                break;
              case 4:
                setTransform('rotateX(180deg)');
                break;
              case 5:
                setTransform('rotateZ(90deg) rotateX(180deg)');
                break;
              case 6:
                setTransform('rotate(90deg)');
                break;
              case 7:
                setTransform('rotateZ(90deg) rotateY(180deg)');
                break;
              case 8:
                setTransform('rotate(-90deg)');
                break;
            }
          }
          this._renderer.setStyle(el, 'visibility', '');
        });
      } else {
        this._renderer.setStyle(el, 'visibility', '');
      }
    });
  }
}
